import React, {Component} from 'react';
import {Table} from 'reactstrap';
import {toast} from 'react-toastify';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import {isEmpty} from 'lodash';

import {getPermission, getUser} from '../../utils/TokenManager';
import {AGENCY_REVENUE_GOAL, downloadPDF} from "../common/Constants";
import ErrorMsg from "../common/ErrorMsg";
import LoadingModal from "../common/LoadingModal";


export default class RevenueGoal extends Component {
    state = {
        revenueTarget: [],
        isLoading: false,
        userId: 0
    };

    auth = {
		user: getUser(),
		permission: getPermission()[AGENCY_REVENUE_GOAL]
	}

    componentDidMount = () => {
        if (this.props.agencyLocation && (!(isEmpty(this.props.defaultAgencyProfile)))) {
            this.getInitialState();
        }
    };

    getInitialState = async () => {
        if (this.auth.permission.can_view) {
            try {
                await this.props.getPlList(this.props.agencyLocation);
            } catch(error) {
                toast.error(<ErrorMsg errors={error}/>);
            }
        }

        if (! parseInt(this.props.defaultAgencyProfile.profileId)) {
            try {
                await this.props.getDefaultAgencyProfile(this.props.agencyLocation);
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>);
            }
        }
        this.getRevenueTarget();
    };

    getRevenueTarget = async () => {
        if (this.props.defaultAgencyProfile.profileId) {
            try {
                let result = await this.props.getRevenueTarget(this.props.defaultAgencyProfile.profileId);
                if (result) {
                    let revenueTarget = result.map(target => ({...target}));
                    this.setState({revenueTarget});
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>);
            }
        } else {
            console.log("No Agency Profile selected.")
            // toast.error("");
        }
    }

    getSelectedPlList = async (e) => {
        try {
            if (e.currentTarget.value) {
                let selectedAgencyProfile = {};
                let selectedProfileId = parseInt(e.currentTarget.value);
                if (!(isEmpty(this.props.plList))) {
                    this.props.plList.plList.map(profile => {
                        if (profile.id === selectedProfileId) {
                            selectedAgencyProfile = {...profile};
                        }
                    });
                }

                // set newly selected agency profile as default
                await this.props.setDefaultAgencyProfile(selectedProfileId, selectedAgencyProfile);
                // Get revenue target list for selected list
                this.getRevenueTarget();
            }
        } catch(error) {
            console.log(error);
        }
    };

    generateTargetReport = async () => {
        if (this.props.defaultAgencyProfile.profileId) {
            this.setState({isLoading: true});
            try {
                let result = await this.props.getRevenueTargetReport(
                    this.props.defaultAgencyProfile.profileId
                );
                
                if (result && 200 === result.status) {
                    let content = result.data.content;
                    let fileName = result.data.file_name;
                    downloadPDF(content, fileName);
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
            this.setState({isLoading: false});
        }
    }

    render() {
        const {revenueTarget} = this.state;
        let currentMonth = moment().format("MMMM");
        let currentMonthGoal = 0;
        let plListOption = [];
        if (!(isEmpty(this.props.plList)) && this.props.plList.plList.length) {
            plListOption = this.props.plList.plList.map((list, index) =>
                <option key={index} value={list.id}>{list.profile}</option>
            );
        }
        let revenueTargetRows = revenueTarget.map((target, index) => {
            if (target.month_name === currentMonth) {
                currentMonthGoal = target.ty_target;
            }
            return (
                <tr key={index}>
                    <td>{target.month_name}</td>
                    <td className="text-center">
                        <NumberFormat value={target.ly_actual} displayType={'text'} thousandSeparator={true} prefix={'$ '} />
                    </td>
                    <td className="text-center">
                        <NumberFormat value={target.ty_planned} displayType={'text'} thousandSeparator={true} prefix={'$ '} />
                    </td>
                    <td className="text-center">
                        <NumberFormat value={target.ty_target} displayType={'text'} thousandSeparator={true} prefix={'$ '} />
                    </td>
                    <td className="text-center">
                        <NumberFormat value={target.ty_actual} displayType={'text'} thousandSeparator={true} prefix={'$ '} />
                    </td>
                </tr>
            );
        });

        return (
            this.auth.permission.can_view ?
            <div className="tab-pane" role="tabpanel">
                <ul className="secondary-menu">
                    <li className="float-left">
                        <label className="bg-primary text-white py-1 px-2 font-16 width-300 mb-0 float-left">
                            <span className="float-left">Current Month Goal: </span>
                            <span className="font-18 box-text-shadow float-right font-weight-bold"><NumberFormat value={currentMonthGoal} displayType={'text'} thousandSeparator={true} prefix={'$ '} /></span>
                        </label>
                    </li>
                    <li className="pl-3 float-left">
                        <label className="mb-0 py-1 px-2">
                            Agency Profile:
                        </label>
                    </li>
                    <li className="pl-1 float-left">                            
                        <select name="plList"
                                className="form-control"
                                onChange={this.getSelectedPlList}
                                value={!(isEmpty(this.props.defaultAgencyProfile)) ?this.props.defaultAgencyProfile.profileId : ""}>
                            <option value="">Select Agency Profile</option>
                            {plListOption}
                        </select>
                    </li>
                    <li className="float-right" onClick={this.generateTargetReport}>
                        <a className="text-info pt-2"> Print</a>
                    </li>
                </ul>
                <br/><br/>
                <Table responsive striped bordered size="sm" className="mb-0">
                    <thead>
                        <tr>
                            <th className="font-weight-bold">Month Name</th>
                            <th className="font-weight-bold text-center">Last Year Actual</th>
                            <th className="font-weight-bold text-center">This Year Planned</th>
                            <th className="font-weight-bold text-center">This Year Target</th>
                            <th className="font-weight-bold text-center">This Year Actual</th>
                        </tr>
                    </thead>
                    <tbody>
                        {revenueTargetRows}
                    </tbody>
                </Table>
                {this.state.isLoading ? <LoadingModal modal={this.state.isLoading} /> : null}
            </div>
            : <div className="tab-pane text-center" role="tabpanel">
                Access Denied
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/revenueGoal/RevenueGoal.js